import { io } from "socket.io-client";
import { getAccessToken } from "../utils/auth";

let socket = null;

export const connectSocket = (userId) => {
  if (socket && socket.connected) {
    return socket;
  }

  const token = getAccessToken();
  const url = process.env.REACT_APP_BASE_URL || window.location.origin;

  socket = io(url, {
    transports: ["websocket"],
    auth: {
      token: token || "",
    },
  });

  socket.on("connect", () => {
    if (userId) {
      socket.emit("join", userId);
    }
  });

  socket.on("disconnect", () => {});

  socket.on("connect_error", (err) => {
    console.error("Socket connect error:", err.message || err);
  });

  return socket;
};

export const getSocket = () => socket;

// import { io } from "socket.io-client";
// import { getToken } from "../utils/auth";

// let socket = null;

// export const connectSocket = (userId) => {
//   if (socket && socket.connected) {
//     // console.log("Socket already connected");
//     return socket;
//   }

//   const token = getToken();
//   const url = process.env.REACT_APP_BASE_URL || window.location.origin;

//   socket = io(url, {
//     transports: ["websocket"],

//     auth: {
//       token: token || "",
//     },
//   });

//   socket.on("connect", () => {
//     // console.log("Connected:", socket.id);

//     if (userId) {
//       socket.emit("join", userId);
//       // console.log("join emitted:", userId);
//     }
//   });

//   socket.on("disconnect", () => {
//     // console.log("Disconnected");
//   });

//   socket.on("connect_error", (err) => {
//     // console.error("Socket connect error:", err.message || err);
//   });

//   return socket;
// };

// export const getSocket = () => socket;
